module.exports = __webpack_public_path__ + "static/media/round16.dad4bdb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/round16.png
// module id = 1167
// module chunks = 0